
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'admin': `Verwaltung`,
'admin.menu.audit': `Audit-Protokolle`,
'admin.menu.directory-auth': `Verzeichnisauthentifizierung`,
'admin.menu.identity-providers': `Identitäts- und Authentifizierungsanbieter`,
'admin.menu.ip-allowlist': `IP-Zulassungsliste`,
'admin.menu.organization-settings': `Organisationseinstellungen`,
'admin.menu.roles': `Rollen`,
'admin.menu.scim-tokens': `SCIM-Token`,
'admin.menu.site-admin': `Standortverwaltung`,
'admin.menu.site-admin.create': `Standort erstellen`,
'admin.menu.user-groups': `Benutzergruppen`,
'admin.menu.users': `Benutzerverwaltung`,
'admin.menu.workload-identities': `Workload-Identitäten`,
'ai-coworkers.menu.agents.deployment': `Bereitstellung`,
'ai-coworkers.menu.agents.events': `Ereignisse`,
'ai-coworkers.menu.control': `Schutz`,
'ai-coworkers.menu.control.exceptions': `Ausnahmeanfragen`,
'ai-coworkers.menu.control.policies': `Richtlinien`,
'ai-coworkers.menu.control.yara-rules': `YARA-Regeln`,
'ai-coworkers.menu.dashboards': `Dashboard`,
'ai-coworkers.menu.intelligence': `Intelligenz`,
'ai-coworkers.menu.intelligence.coding-sessions': `KI-Sitzungen`,
'ai-coworkers.menu.inventory': `Sichtbarkeit`,
'ai-coworkers.menu.inventory.agent-skills': `Agentenfähigkeiten`,
'ai-coworkers.menu.inventory.agents': `KI-Agenten`,
'ai-coworkers.menu.inventory.endpoints': `Endpunkte`,
'ai-coworkers.menu.inventory.mcp-servers': `MCP-Server`,
'ai-coworkers.menu.inventory.model-endpoints': `LLM-Endpunkte`,
'ai-coworkers.menu.settings': `Einstellungen`,
'ai-coworkers.menu.settings.administration': `Verwaltung`,
'ai-coworkers.menu.settings.connectors': `Konnektoren`,
'ai-coworkers.menu.settings.license': `Lizenz &amp; Nutzung`,
'ai-coworkers.menu.settings.update-strategy': `Update-Strategie`,
'analytics': `Analytik`,
'appliance': `Appliance`,
'auditing': `Auditing`,
'breadcrumbNavLabel': `Navigationspfad`,
'breadcrumbOverflowLabel': `Weitere Navigationselemente anzeigen`,
'computer-groups': `Computergruppen`,
'computers': `Computer`,
'configuration': `Konfiguration`,
'dashboard': `Dashboards`,
'downloads': `Konsolen und Downloads`,
'entitle.menu.accessReview': `Übersicht`,
'entitle.menu.auditLogs': `Audit-Protokolle`,
'entitle.menu.bundles': `Pakete`,
'entitle.menu.identityGraph': `Berechtigungen`,
'entitle.menu.integrations': `Integrationen`,
'entitle.menu.policies': `Grundrechte-Richtlinien`,
'entitle.menu.profile': `Meine Einstellungen`,
'entitle.menu.requests': `Anfragen`,
'entitle.menu.requestsLog': `Anfragenverlauf`,
'entitle.menu.settings': `Organisationseinstellungen`,
'entitle.menu.tasks': `Aufgaben`,
'entitle.menu.users': `Benutzer`,
'entitle.menu.workflows': `Genehmigungsabläufe`,
'epml.menu.audit': `Audit`,
'epml.menu.consoleAccess': `Konsolenzugriff`,
'epml.menu.consoleAudit': `Konsolen-Audit`,
'epml.menu.directoryServices': `Verzeichnisdienste`,
'epml.menu.endpoints': `Endpunktverwaltung`,
'epml.menu.epmlSettings': `EPML-Einstellungen`,
'epml.menu.events': `Ereignisse`,
'epml.menu.explore': `Erkunden`,
'epml.menu.installers': `Installationsprogramme`,
'epml.menu.linuxHostAuth': `Linux-Host-Authentifizierung`,
'epml.menu.policy': `Richtlinie`,
'epml.menu.roles': `Rollen`,
'epml.menu.searchAndReplay': `Suche und Wiedergabe`,
'epml.menu.settings': `Einstellungen`,
'epml.menu.siemConnections': `SIEM-Verbindungen`,
'epml.menu.unifiedSearch': `Einheitliche Suche`,
'home': `Startseite`,
'insights.menu.accounts': `Konten`,
'insights.menu.agentInventory': `Agenteninventar`,
'insights.menu.aiAgents': `KI-Agenten`,
'insights.menu.aiSecurity': `KI-Sicherheit`,
'insights.menu.aiThreatDetection': `Bedrohungserkennung`,
'insights.menu.aiThreatPolicy': `Bedrohungsrichtlinie`,
'insights.menu.connectors': `Konnektoren`,
'insights.menu.dashboard': `Dashboard`,
'insights.menu.detections': `Erkennungen`,
'insights.menu.entitlements': `Berechtigungen`,
'insights.menu.exclusionRules': `Ausschlussregeln`,
'insights.menu.identities': `Identitäten`,
'insights.menu.identitiesPrivileges': `Identitäten und Berechtigungen`,
'insights.menu.insights': `Insights`,
'insights.menu.integrations': `Integrationen`,
'insights.menu.integrationsConnections': `Integrationen und Verbindungen`,
'insights.menu.recommendations': `Empfehlungen`,
'insights.menu.reporting': `Berichterstellung`,
'insights.menu.secrets': `Geheimnisse`,
'insights.menu.secretsInventory': `Geheimnissinventar`,
'insights.menu.secretsSecurity': `Geheimnissicherheit`,
'jit-access-management': `JIT-Zugriffsverwaltung`,
'jump': `Asset Management`,
'localization': `Lokalisierung`,
'login.account_policy.index': `Kontorichtlinien`,
'login.api_account.index': `API-Konfiguration`,
'login.appliance.index': `Appliance`,
'login.business_hours.index': `Zeitplan`,
'login.callback_button.index': `Support-Schaltflächen`,
'login.canned_message.index': `Vordefinierte Nachrichten`,
'login.canned_script.index': `Vordefinierte Skripte`,
'login.compliance.index': `Compliance`,
'login.custom_fields.index': `Benutzerdefinierte Felder`,
'login.custom_links.index': `Benutzerdefinierte Links`,
'login.customer_notice.index': `Kundenhinweise`,
'login.dashboard.getNetworkRestrictions': `Netzwerkeinschränkungen`,
'login.dashboard.index': `Dashboards`,
'login.discovery.index': `Erkennung`,
'login.downloads.drivers.index': `Treiber`,
'login.downloads.rep.index': `Rep Console`,
'login.duplicate_pinned_clients_reporting.index': `Doppelte Jump Clients`,
'login.email_settings.index': `E-Mail-Konfiguration`,
'login.endpoint_automation.index': `Endpunktautomatisierung`,
'login.exit_survey.index': `Abschlussumfragen`,
'login.file_store.index': `Dateispeicher`,
'login.group_policy.index': `Gruppenrichtlinien`,
'login.html_template.index': `HTML-Vorlagen`,
'login.ios_profile.index': `iOS-Konfiguration`,
'login.issue.index': `Probleme`,
'login.jump_item_reporting.index': `Asset`,
'login.jump_item_roles.index': `Asset Roles`,
'login.jump_item.index': `Assets`,
'login.jump_policies.index': `Asset Policies`,
'login.kerberos_keytab.index': `Kerberos Keytab`,
'login.license_reporting.index': `Lizenzierung`,
'login.licensing.index': `Lizenzierung`,
'login.mcp_config.index': `MCP-Server`,
'login.ms_teams.index': `MS Teams`,
'login.my_account.profile.index': `Profil`,
'login.my_account.security.index': `Sicherheit`,
'login.nls.real_time_chat.index': `Echtzeit-Chat`,
'login.outbound_event.index': `Ausgehende Ereignisse`,
'login.pinned_clients.index': `Jump Clients`,
'login.public_site.index': `Öffentliche Websites`,
'login.push_agent.index': `Gateway`,
'login.rep_invite.index': `Vertretereinladung`,
'login.rep_profile.index': `Rep Console-Einstellungen`,
'login.sd_client.index': `Support-Client`,
'login.sd_general.index': `Optionen`,
'login.security_providers.index': `Sicherheitsanbieter`,
'login.security_settings.index': `Sicherheit`,
'login.session_policy.index': `Sitzungsrichtlinien`,
'login.session_report.index': `Support`,
'login.settings.index': `Software`,
'login.shared_jump_groups.index': `Asset Groups`,
'login.site_settings.index': `Standortkonfiguration`,
'login.skill.index': `Fähigkeiten`,
'login.special_action.index': `Spezialaktionen`,
'login.status_representatives.index': `Vertreter`,
'login.status.index': `Informationen`,
'login.support_settings.index': `Support`,
'login.syslog_reporting.index': `Syslog`,
'login.team.index': `Supportteams`,
'login.user.index': `Benutzer`,
'login.vault_account_group.index': `Kontogruppen`,
'login.vault_account.index': `Konten`,
'login.vault_domain.index': `Domänen`,
'login.vault_endpoint.index': `Endpunkte`,
'login.vault_options.index': `Optionen`,
'login.vault_password_safe_connection.index': `Verbindungen`,
'login.vault_reporting.index': `Tresor`,
'management': `Verwaltung`,
'management-rules': `Verwaltungsregeln`,
'menu-phantom-labs': `Phantom Labs`,
'my_account': `Mein Konto`,
'pmc.audit': `Audit`,
'pmc.explore': `Erkunden`,
'pmc.settings': `Einstellungen`,
'policies': `Richtlinien`,
'public_site': `Öffentliche Portale`,
'rep_console': `Konsoleneinstellungen`,
'reporting': `Berichte`,
's352719d86112de9a': `Hilfe`,
's3741f519c32ac391': `Neu`,
's3d64ea063be4c9f2': `Einheitliches Auditing`,
's416434bef0c17abc': `Das Menü konnte nicht geladen werden. Schließen Sie es und öffnen Sie es erneut, um es noch einmal zu versuchen.`,
's417b90913e05bc17': `Vorschau`,
's49730f3d5751a433': `Wird geladen...`,
's4c9351ce0cc28196': `Produktnavigation`,
's596a144afb429d94': `Weitere Produkte`,
's5e8250fb85d64c23': `Schließen`,
's691d6163aaabb69b': `Benutzerprofil`,
's6abb1cd87fe0114e': `Startseite`,
's6d8c02aee480af7a': `Menü`,
's714ea1e6436002a2': `Navigation angeheftet halten`,
's76902262e33e63b5': `Seitenleistennavigation umschalten`,
'sd': `Konfiguration`,
'sffe2914d4b7c91ee': `Frühzugang`,
'sitemenu.about': `Über`,
'sitemenu.analytics': `Analytik und Berichterstellung`,
'sitemenu.analyticsandreporting.viewallreports': `Alle Berichte anzeigen`,
'sitemenu.analyticsandreportingtrident': `Analytik und Berichterstellung`,
'sitemenu.assets': `Assets`,
'sitemenu.configuration': `Konfiguration`,
'sitemenu.dashboard': `Dashboard`,
'sitemenu.dashboard.dynamicdashboard': `Dashboard (Vorschau)`,
'sitemenu.discovery': `Erkennung`,
'sitemenu.discovery.activeandcompletedscans': `Aktive/Abgeschlossene Scans`,
'sitemenu.discovery.discoveryscanners': `Erkennungsscanner`,
'sitemenu.discovery.newdiscoveryscan': `Neuen Erkennungsscan ausführen`,
'sitemenu.discovery.scheduledscans': `Geplante Scans`,
'sitemenu.managedaccounts': `Verwaltete Konten`,
'sitemenu.managedsystems': `Verwaltete Systeme`,
'sitemenu.passwordsafe': `Password Safe`,
'sitemenu.passwordsafe.accounts': `Konten`,
'sitemenu.passwordsafe.activesessions': `Aktive Sitzungen`,
'sitemenu.passwordsafe.administratorsessions': `Admin-Sitzungen`,
'sitemenu.passwordsafe.approvals': `Genehmigungen`,
'sitemenu.passwordsafe.completedsessions': `Abgeschlossene Sitzungen`,
'sitemenu.smartrules': `Intelligente Regeln`,
'sitemenu.teampasswords': `Secrets Safe`,
'siteSelectorDataResidency': `Datenresidenz`,
'siteSelectorLabel': `Site`,
'siteSelectorNoSitesFound': `Keine Sites gefunden`,
'siteSelectorSearchPlaceholder': `Sites suchen`,
'status': `Status`,
'user-management': `Benutzerverwaltung`,
'users': `Benutzer und Sicherheit`,
'vault': `Tresor`,
    };
  